// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"5":"home-desktop-taxonomy-css","671":"home-desktop-taxonomy","939":"browse-card-ui"}[chunkId] || chunkId) + "-" + {"5":"85394f1f68","289":"200ddb60fd","671":"17c1732097","939":"f726cc63b6"}[chunkId] + ".js";
};